import siteType from "../configs/siteType"

/* eslint-disable */
let register = {}
if (siteType.GetSiteType() == siteType.SITE_TYPE_NUTS) {
  register = {
    "LAB_CLUB_INVITE_H5_WELCOME": "{club}へようこそ",
    "LAB_CLUB_INVITE_H5_WELCOME_LONG": "登録後にこのクラブに入会となります",
    "LAB_REGISTER_USERNAME": "ユーザーネーム",
    "LAB_AUTH_EMAIL": "Eメール",
    "LAB_ACCOUNT_EMAIL_FORM_WRONG": "無効なメールアドレス",
    "LAB_ACCOUNT_ALREADY_REGISTERED": "*このメールアドレスは既に登録されています。",
    "LAB_KYC_INVALID_EMAIL": "このアドレスは使用不可となっています。",
    "LAB_ACCOUNT_FORMAT_TIP": "ユーザーネームは4-30文字の英字または数字が必要です",
    "LAB_ACCOUNT_FORMAT_TIP2": "ユーザーネームにはスペースや特殊文字を含めることはできません",
    "LAB_PASSWORD": "パスワード",
    "LAB_REGISTER_PASSWORD_TIP2": "パスワードの長さは6～16文字でお願いします。また、アルファベット・数字それぞれを最低1文字ずつ含む必要があります。",
    "LAB_REGISTER_PASSWORD_TIP3": "「{word}」はパスワードに使用できません。",
    "LAB_REGISTER_PASSWORD_TIP4": "スペースはパスワードに使用できません。",
    "LAB_CLUB_INVITE_H5_Verifiy": "検証コード",
    "LAB_VERIFICATION_CODE_ERROR": "検証コード間違いました",
    "LAB_REGISTER_RIGHT_NOW": "登録",
    "LAB_CLUB_INVITE_H5_Download_1": "アカウントをお持ちですか？",
    "LAB_CLUB_INVITE_H5_Download_2": "今すぐダウンロード",
    "LAB_CLUB_INVITE_H5_Success": "登録成功！",
    "LAB_CLUB_CHECK_TEMS1": "私が年齢が 18 歳以上であることを認めます。",
    "LAB_CLUB_CHECK_TEMS2": "利用規約",
    "LAB_CLUB_CHECK_TEMS3": "と",
    "LAB_CLUB_CHECK_TEMS4": "個人情報保護方針",
    "LAB_CLUB_CHECK_TIPS": "利用規約と個人情報保護方針に同意したことを示してください。",
    "LAB_REGISTER_MUCH": "複数登録は禁止",
    "LAB_CLUB_INVITE_CODE_ERROR": "無効な招待コードです！",
    "LAB_HISTORY_SHARE_ERROR": "失敗しました。後でもう一度お試しください。",
    "LAB_H5_Marketing_Programme": "関連会社のマーケティングプログラム要件",
    "LAB_H5_CHECK_TIPS": "ここにチェックを入力し、あなたが 18 歳以上であることを確認し、{link1}、{link2}、{link3}に同意されたことを提示してください。",
    "LAB_PLAY_NOW": "今すぐプレイ！",
    "LAB_TITLE_1": "キャッシュバック保証",
    "LAB_CONTENT_1": "最大50%のInstant Rakebackを、\n毎ゲーム終了後に受け取れます。",
    "LAB_TITLE_2": "グローバルプレイヤー",
    "LAB_CONTENT_2": "多彩でエキサイティングなゲームが毎日 24 時間開催されています！",
    "LAB_TITLE_3": "ノンストップボーナス",
    "LAB_CONTENT_3": "リーダーボード、キャッシュストーム、ミッション、\nジャックポットをプレイして超高額リワードを稼ごう。",
    "LAB_TITLE_4": "資金の安全性を確保",
    "LAB_CONTENT_4": "マン島ギャンブル監督委員会のライセンスを取得した、ティア 1 オンラインポーカー",
    "LAB_BE_MORE": "NUTS POKER で一流のプレイヤーになろう！",
    "LAB_PLAY_BEST": "最高のポーカーゲームを今すぐプレイ！",
    "LAB_SERVICE": "以下NUTS POKERの (ウェブサイト、タブレット、モバイルアプリ経由で提供される) 製品やサービスを、「サービス」と総称します。",
    "LAB_ENJOY": "エキサイティングで多種多様なポーカーを楽しめる",
    "LAB_MORE": "NLH、PLO、OFCなどなど！ ",
    "LAB_PLAY_GAME": "ポーカーゲームの様々なバリエーションをプレイしましょう！",
    "LAB_MODE": "ノーリミット・テキサス・ホールデム、PLO、6+、OFCといったクラシックから今流行りのポーカーゲームまでが勢ぞろい。アグレッシブ、ウルティメット、ジョーカーモードなどでスリルも満点。",
    "LAB_TODAY": "今すぐ参加しましょう！",
    "LAB_ACTION": "3つのアクション\n同時進行で、3倍楽しめる",
    "LAB_MASTER": "マルチテーブル・マスターを目指せ",
    "LAB_SAME_TIME": "マルチテーブル機能によって、同時に三つのテーブルでプレイが可能！",
    "LAB_SWIPE": "自分のターンになるとテーブルがハイライト表示され、テーブルまでの移動もスワイプ一つで可能なユーザーに優しい親切設計。",
    "LAB_SAFE": "安全で公正なゲーム体験",
    "LAB_ASSEM": "専属の不正行為対策チームが集まる！",
    "LAB_RULES": "NUTS POKERは、不正プレイに厳格に対処します。ルールに違反したアカウントは永久追放処分となります。",
    "LAB_TABLES": "不正行為対策によって、エキスパートチームがプレイ中の怪しい行動などを監視しています。",
    "LAB_EVERY_DAY": "安全かつ公平なNUTS POKERでのプレイを毎日お楽しみください！",
    "LAB_ACCESS": "\n{link}に居住する、あるいは滞在する住人がサービスにアクセスすることが違法行為となる場合もあります。賭け、ゲーム、その他のサービスが法律によって禁止されている国における利用は、NUTS POKERによるサービス利用への勧誘や招待、ゲームのサブスクリプション登録の対象ではありません。特に、米国の居住者または米国に滞在する人物は、本サービスを使用することができません。",
    "LAB_BRAND": "NUTS POKERは、「AceKing IOM Limited, 49 Victoria Street, Douglas, Isle of Man, IM1 2LD」による登録商標です。",
    "LAB_GAMEBLING": "「Isle of Man Gambling Supervision Commission」によるオンラインギャンブル関連法に従った管理体制の設置と運営許可の付与が行われています",
    "LAB_AGE": "2019年7月24日（最終更新日2019年7月24日）より「Regulation Act 2001」準拠。18歳未満の方によるアカウント作成/ギャンブルへの参加は認められていません。NUTS POKERでの入金や賞金獲得はマン島の法律によって保護されています。",
    "LAB_FOLLOW": "フォローします",
    "LAB_COUNTRIES": "特定の国",
    "LAB_ABOUT": "連絡先",
    "LAB_POLICY": "個人情報保護方針",
    "LAB_TERM": "利用規約",
    "LAB_COPY": "Copyright © {link} NUTS POKER. All Rights Reserved.",
    "LAB_DOWNLOAD": "ダウンロード",
    "LAB_VERIFICATION": "認証",
    "LAB_PLEASE_TYPE": "画像に表示されている文字を入力してください",
    "LAB_CONFIRM": "確認",
    "LAB_SERVICE_CO": "NUTS POKER Globalが提供する製品とサービス(ウェブサイト、タブレット、携帯アプリなどを経由して)は、「サービス」と呼ばれることがあります。",
    "LAB_ACCESS_CO": "{link}にお住まいの、または滞在しているお客さまは、当サービスにアクセスすることが違法となる場合があります。この場合、NUTS POKER Globalが登録、ベット、ゲーム、その他司法権が違法と判断する、いかなるサービスの目的で提供するサービスにオファー、勧誘、招待は構成されません。アメリカ合衆国にお住まいの、または滞在しているお客さまは、これらのサービスを利用できません。",
    "LAB_GAMEBLING_CO": "NUTS POKER Globalと発生する入金または損益は、キュラソー島の法律に保護され、適用されます。",
    "LAB_AGE_CO": "18歳未満のお客さまは、アカウントを作成すること、そして/またはギャンブルに参加することはは許可されていません。",
    "LAB_CLUB_CHECK_TEMS4_CO": "プライバシー＆個人データ管理規約",
    "LAB_PRIVACYPOLICE_CO": "プライバシー＆個人データ",
    "LAB_CONTENT_4_CO": "Curaçao eGaming発行のフルライセンスに基づき規範されています。",
    "LAB_VERIFY_EMAIL": "メールアドレスを認証してください",
    "LAB_VERIFY_EMAIL_ADDRESS": "{email address}にEメールを送信しました",
    "LAB_VERIFY_TIPS": "メールアドレスを認証してアカウントを有効にするには、送信したEメールの認証リンクをクリックしてください。受信していない場合は、迷惑メールフォルダを確認してください。",
    "LAB_VERIFY_RESEND": "Eメール再送信",
    "LAB_VERIFY_CODE_TIPS": "画像に表示されている文字を入力してボットではないことを証明してください。",
    "LAB_EMAIL_VERIFIED": "メールアドレス認証済",
    "LAB_EMAIL_DOWNLOAD_TIPS": "アカウントが作成できました！<br>以下のボタンをクリックし、NUTS POKERをダウンロードしてポーカーを楽しみしましょう！",
    "LAB_EMAIL_DOWNLOAD": "NUTS POKERをダウンロード",
    "LAB_EMAIL_VERIFY_ACCOUNT": "NUTS POKERのアカウント認証について",
    "LAB_EMAIL_EXPIRED_1": "こちらのリンクが無効になりました",
    "LAB_EMAIL_EXPIRED_2": "登録ページにアクセスし、新しい認証リンクをご発行ください。",
    "LAB_VERIFY_PROTECT": "個人情報の保護",
    "LAB_EMAIL_FAILED": "失敗しました。後ほど再試行してください"
  }
} else {
  register = {
    "LAB_CLUB_INVITE_H5_WELCOME": "{club}へようこそ",
    "LAB_CLUB_INVITE_H5_WELCOME_LONG": "登録後にこのクラブに入会となります",
    "LAB_REGISTER_USERNAME": "ユーザーネーム",
    "LAB_AUTH_EMAIL": "Eメール",
    "LAB_ACCOUNT_EMAIL_FORM_WRONG": "無効なメールアドレス",
    "LAB_ACCOUNT_ALREADY_REGISTERED": "*このメールアドレスは既に登録されています。",
    "LAB_KYC_INVALID_EMAIL": "このアドレスは使用不可となっています。",
    "LAB_ACCOUNT_FORMAT_TIP": "ユーザーネームは4-30文字の英字または数字が必要です",
    "LAB_ACCOUNT_FORMAT_TIP2": "ユーザーネームにはスペースや特殊文字を含めることはできません",
    "LAB_PASSWORD": "パスワード",
    "LAB_REGISTER_PASSWORD_TIP2": "パスワードは8～16文字で、大文字 ･ 小文字 ･ 数字をすべて含めてください。",
    "LAB_REGISTER_PASSWORD_TIP3": "「{word}」はパスワードに使用できません。",
    "LAB_REGISTER_PASSWORD_TIP4": "スペースはパスワードに使用できません。",
    "LAB_CLUB_INVITE_H5_Verifiy": "検証コード",
    "LAB_VERIFICATION_CODE_ERROR": "検証コード間違いました",
    "LAB_REGISTER_RIGHT_NOW": "登録",
    "LAB_CLUB_INVITE_H5_Download_1": "アカウントをお持ちですか？",
    "LAB_CLUB_INVITE_H5_Download_2": "今すぐダウンロード",
    "LAB_CLUB_INVITE_H5_Success": "登録成功！",
    "LAB_CLUB_CHECK_TEMS1": "私が年齢が 18 歳以上であることを認めます。",
    "LAB_CLUB_CHECK_TEMS2": "利用規約",
    "LAB_CLUB_CHECK_TEMS3": "と",
    "LAB_CLUB_CHECK_TEMS4": "個人情報保護方針",
    "LAB_CLUB_CHECK_TIPS": "利用規約と個人情報保護方針に同意したことを示してください。",
    "LAB_REGISTER_MUCH": "複数登録は禁止",
    "LAB_CLUB_INVITE_CODE_ERROR": "無効な招待コードです！",
    "LAB_HISTORY_SHARE_ERROR": "失敗しました。後でもう一度お試しください。",
    "LAB_H5_Marketing_Programme": "関連会社のマーケティングプログラム要件",
    "LAB_H5_CHECK_TIPS": "ここにチェックを入力し、あなたが 18 歳以上であることを確認し、{link1}、{link2}、{link3}に同意されたことを提示してください。",
    "LAB_PLAY_NOW": "今すぐプレイ！",
    "LAB_TITLE_1": "キャッシュバック保証",
    "LAB_CONTENT_1": "最大50%のInstant Rakebackを、\r\n毎ゲーム終了後に受け取れます。",
    "LAB_TITLE_2": "グローバルプレイヤー",
    "LAB_CONTENT_2": "多彩でエキサイティングなゲームが毎日 24 時間開催されています！",
    "LAB_TITLE_3": "ノンストップボーナス",
    "LAB_CONTENT_3": "リーダーボード、キャッシュストーム、ミッション、\r\nジャックポットをプレイして超高額リワードを稼ごう。",
    "LAB_TITLE_4": "資金の安全性を確保",
    "LAB_CONTENT_4": "マン島ギャンブル監督委員会のライセンスを取得した、ティア 1 オンラインポーカー",
    "LAB_BE_MORE": "KKPoker で一流のプレイヤーになろう！",
    "LAB_PLAY_BEST": "最高のポーカーゲームを今すぐプレイ！",
    "LAB_SERVICE": "以下KKPokerの (ウェブサイト、タブレット、モバイルアプリ経由で提供される) 製品やサービスを、「サービス」と総称します。",
    "LAB_ENJOY": "エキサイティングで多種多様なポーカーを楽しめる",
    "LAB_MORE": "NLH、PLO、OFCなどなど！ ",
    "LAB_PLAY_GAME": "ポーカーゲームの様々なバリエーションをプレイしましょう！",
    "LAB_MODE": "ノーリミット・テキサス・ホールデム、PLO、6+、OFCといったクラシックから今流行りのポーカーゲームまでが勢ぞろい。アグレッシブ、ウルティメット、ジョーカーモードなどでスリルも満点。",
    "LAB_TODAY": "今すぐ参加しましょう！",
    "LAB_ACTION": "3つのアクション\r\n同時進行で、3倍楽しめる",
    "LAB_MASTER": "マルチテーブル・マスターを目指せ",
    "LAB_SAME_TIME": "マルチテーブル機能によって、同時に三つのテーブルでプレイが可能！",
    "LAB_SWIPE": "自分のターンになるとテーブルがハイライト表示され、テーブルまでの移動もスワイプ一つで可能なユーザーに優しい親切設計。",
    "LAB_SAFE": "安全で公正なゲーム体験",
    "LAB_ASSEM": "専属の不正行為対策チームが集まる！",
    "LAB_RULES": "KKPokerは、不正プレイに厳格に対処します。ルールに違反したアカウントは永久追放処分となります。",
    "LAB_TABLES": "不正行為対策によって、エキスパートチームがプレイ中の怪しい行動などを監視しています。",
    "LAB_EVERY_DAY": "安全かつ公平なKKPokerでのプレイを毎日お楽しみください！",
    "LAB_ACCESS": "\r\n{link}に居住する、あるいは滞在する住人がサービスにアクセスすることが違法行為となる場合もあります。賭け、ゲーム、その他のサービスが法律によって禁止されている国における利用は、KKPokerによるサービス利用への勧誘や招待、ゲームのサブスクリプション登録の対象ではありません。特に、米国の居住者または米国に滞在する人物は、本サービスを使用することができません。",
    "LAB_BRAND": "KKPokerは、「AceKing IOM Limited, 49 Victoria Street, Douglas, Isle of Man, IM1 2LD」による登録商標です。",
    "LAB_GAMEBLING": "「Isle of Man Gambling Supervision Commission」によるオンラインギャンブル関連法に従った管理体制の設置と運営許可の付与が行われています",
    "LAB_AGE": "2019年7月24日（最終更新日2019年7月24日）より「Regulation Act 2001」準拠。18歳未満の方によるアカウント作成/ギャンブルへの参加は認められていません。KKPokerでの入金や賞金獲得はマン島の法律によって保護されています。",
    "LAB_FOLLOW": "フォローします",
    "LAB_COUNTRIES": "特定の国",
    "LAB_ABOUT": "連絡先",
    "LAB_POLICY": "個人情報保護方針",
    "LAB_TERM": "利用規約",
    "LAB_COPY": "Copyright © {link} KKPoker. All Rights Reserved.",
    "LAB_DOWNLOAD": "ダウンロード",
    "LAB_VERIFICATION": "認証",
    "LAB_PLEASE_TYPE": "画像に表示されている文字を入力してください",
    "LAB_CONFIRM": "確認",
    "LAB_SERVICE_CO": "KKPoker Globalが提供する製品とサービス(ウェブサイト、タブレット、携帯アプリなどを経由して)は、「サービス」と呼ばれることがあります。",
    "LAB_ACCESS_CO": "{link}にお住まいの、または滞在しているお客さまは、当サービスにアクセスすることが違法となる場合があります。この場合、KKPoker Globalが登録、ベット、ゲーム、その他司法権が違法と判断する、いかなるサービスの目的で提供するサービスにオファー、勧誘、招待は構成されません。アメリカ合衆国にお住まいの、または滞在しているお客さまは、これらのサービスを利用できません。",
    "LAB_BRAND_CO": "kkpoker.coはViolet Fortune Tech Limited N.V. が運営してNo. 158923でPerseusweg 27A, Willemstad, キュラソー島にて登録されています。このウェブサイトはCuraçao eGamingによりライセンスが付与され、規制されています(CuraçaoライセンスNo. 1668 JAZ 発行元Curaçao eGaming)。",
    "LAB_GAMEBLING_CO": "KKPoker Globalと発生する入金または損益は、キュラソー島の法律に保護され、適用されます。",
    "LAB_AGE_CO": "18歳未満のお客さまは、アカウントを作成すること、そして/またはギャンブルに参加することはは許可されていません。",
    "LAB_CLUB_CHECK_TEMS4_CO": "プライバシー＆個人データ管理規約",
    "LAB_PRIVACYPOLICE_CO": "プライバシー＆個人データ",
    "LAB_CONTENT_4_CO": "Curaçao eGaming発行のフルライセンスに基づき規範されています。",
    "LAB_VERIFY_EMAIL": "メールアドレスを認証してください",
    "LAB_VERIFY_EMAIL_ADDRESS": "{email address}にEメールを送信しました",
    "LAB_VERIFY_TIPS": "メールアドレスを認証してアカウントを有効にするには、送信したEメールの認証リンクをクリックしてください。受信していない場合は、迷惑メールフォルダを確認してください。",
    "LAB_VERIFY_RESEND": "Eメール再送信",
    "LAB_VERIFY_CODE_TIPS": "画像に表示されている文字を入力してボットではないことを証明してください。",
    "LAB_EMAIL_VERIFIED": "メールアドレス認証済",
    "LAB_EMAIL_DOWNLOAD_TIPS": "アカウントが作成できました！<br>以下のボタンをクリックし、KKPokerをダウンロードしてポーカーを楽しみしましょう！",
    "LAB_EMAIL_DOWNLOAD": "KKPokerをダウンロード",
    "LAB_EMAIL_VERIFY_ACCOUNT": "KKPokerのアカウント認証について",
    "LAB_EMAIL_EXPIRED_1": "こちらのリンクが無効になりました",
    "LAB_EMAIL_EXPIRED_2": "登録ページにアクセスし、新しい認証リンクをご発行ください。",
    "LAB_VERIFY_PROTECT": "個人情報の保護",
    "LAB_EMAIL_FAILED": "失敗しました。後ほど再試行してください"
  }
}

export default {
  "register": register
}